import axios from 'api/axios'
import { Invoice } from 'types'
import handleAxiosError from 'utils/handleAxiosError'

/**
 * Type Interface of objects that can be used in the API for New Invoice
 */

export interface NewInvoiceBody {
	amount: number
	client: string
	url: string
	number: string
	dueDate: string
	deactivation: boolean
	tdsEnabled: boolean
	createdDate?: string
	isSilentInvoice: boolean
}

/**
 * API call create a new Invoice
 * @param body InvoiceBody - data to be send to backend for generating new invoice
 * @returns NewInvoiceResponse - Response object returned from the server
 */

export const createNewInvoice = async (body: NewInvoiceBody) => {
	try {
		const { data } = await axios.post<Invoice>(`client/bill/invoice`, body)

		return data
	} catch (error: any) {
		handleAxiosError(error)
		throw error
	}
}

export default createNewInvoice
